import { Bindable, NotifyProperty, nameof } from "bindable-data";
import { INewsModel } from "./INewsModel";
import { NewsCard } from "../flow/impl/news/NewsCard";
import { inject, injectable } from "@launchtray/tsyringe-async";
import { IGameModel } from "./IGameModel";
import { NewsAction } from "../flow/impl/NewsAction";
import { RaidNewsCard } from "../flow/impl/news/RaidNewsCard";
import { NewsType } from "../../../networking/data/responses/news/NewsType";
import { VisitNewsCard } from "../flow/impl/news/VisitNewsCard";
import { StealNewsCard } from "../flow/impl/news/StealNewsCard";
import { NewsDto } from "../../../networking/data/responses/news/NewsDto";

@injectable()
export class NewsModel extends Bindable implements INewsModel {
    public readonly news: NotifyProperty<NewsCard>;
    private readonly newsQueue: Array<NewsCard>;
    private readonly gameModel: IGameModel;

    public constructor(@inject("IGameModel") gameModel: IGameModel) {
        super();
        this.news = new NotifyProperty<NewsCard>(this, nameof(this, "news"), null);
        this.newsQueue = new Array<NewsCard>();
        this.gameModel = gameModel;
        this.gameModel.propertyChanged.add(this.onGameModelPropertyChange, this);
        this.onGameModelPropertyChange(this.gameModel, nameof(this.gameModel, "action"));
    }

    public async markRead(): Promise<void> {
        if (this.newsQueue.length > 0) {
            this.news.setValue(this.newsQueue.shift());
        } else {
            this.news.setValue(null);
        }
    }

    public async claimAction(): Promise<void> {
        const result = await this.gameModel.claimAction();

        const dto: NewsDto = {
            type: this.news.value.type,
            guest: result.guest,
            building: result.building,
            costInShields: result.costInShields,
            rewardInCoins: result.rewardInCoins,
            stealAmountInCoins: result.stealAmountInCoins,
        }

        switch (this.news.value.type) {
            case NewsType.RAID:
                this.news.setValue(new RaidNewsCard(dto, true));
                break;
            case NewsType.VISIT:
                this.news.setValue(new VisitNewsCard(dto, true));
                break;
            case NewsType.STEAL:
                this.news.setValue(new StealNewsCard(dto, true));
                break;
        }
    }

    private onGameModelPropertyChange(model: IGameModel, key: string) {
        switch (key) {
            case nameof(model, "action"):
                if (model.action.value === null) {
                    return;
                }
                switch (model.action.value.constructor) {
                    case NewsAction:
                        const action = model.action.value as NewsAction;
                        if (this.news.value == null) {
                            this.news.setValue(action.news);
                        } else {
                            this.newsQueue.push(action.news);
                        }
                        break;
                }
                break;
        }
    }
}
